/*Popups*/

var sema = false;
$(document).on("click", ".popup-trigger", function(e){
    e.preventDefault();
    if(sema) return;
    sema = true;
    var type = $(this).data("type");
    var trigger = $(this).data("trigger");
    var skipReset = $(this).data("skip-reset");
    switch(trigger){
        case "open":
            popup_open(type);
            break;
        case "close":
            popup_close(type, skipReset);
        default:
            break;
    }
    setTimeout(function(){
        sema = false;
    }, 500);
});

window.popup_open = function(type, data) {
    $(".popup[data-type='"+type+"']").addClass("active");
    if (data) {
        $(".popup[data-type='" + type + "']").data('value', data);
    }
    $(window).trigger("popup_open", [type, data]);
    $('.popup.active').find('.popup-content')
    .addClass('mw-100')
    .css({width: $('.popup.active').find('.popup-content').data('width') || 700})
    .resizable({
        minWidth: 625,
        minHeight: 175,
        handles: 'e',
    })
};

window.popup_close = function(type, skipReset = false){
    var popup = $(".popup[data-type='"+type+"']");
    popup.css("opacity", 0);
    setTimeout(function() {
        popup.removeClass("active").css("opacity", 1);
        if (!skipReset) {
            popup.find('input:hidden:not(.important):not([name="dataTable"])').val("").trigger('change');
            popup.find('form').trigger('reset');
            popup.find('.select2-hidden-accessible').trigger('change');
            $(".popup[data-type='" + type + "']").data('value', null);
        }
    }, 250);
    $(window).trigger("popup_close", [type]);
};



// WEBPACK FOOTER //
// ./resources/assets/js/popup.js